"use strict";
var r, e;
function s() {
  return e || (e = 1, r = Error), r;
}
export {
  s as __require
};
//# sourceMappingURL=index.es304.js.map
